import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { IconButton } from 'react-native-paper';
import { processFontFamily } from '../../util.style';

interface UserInfoProps {
  isCollapsed: boolean;
  textColor: string;
  userName?: string;
  email?: string;
  fontFamily?: string;
  isCanvasMode?: boolean;
}

export const UserInfo: React.FC<UserInfoProps> = ({
  isCollapsed,
  textColor,
  userName = '田中 太郎',
  email = 'mail@sample.com',
  fontFamily,
  isCanvasMode = false,
}) => {
  const containerStyle = {
    flexDirection: 'column' as const,
    alignItems: 'flex-start' as const,
    paddingVertical: isCollapsed ? 12 : 0,
    paddingHorizontal: isCollapsed ? 35 : 0,
    marginHorizontal: isCollapsed ? 8 : 0,
    borderRadius: 8,
  };

  if (isCollapsed) {
    return null;
  }

  return (
    <View style={containerStyle as any}>
      <Text
        style={{
          color: textColor,
          fontSize: 12,
          fontFamily: fontFamily,
          textAlign: 'left' as const,
          opacity: 0.8,
          marginBottom: 4,
        }}
      >
        {email}
      </Text>
      <Text
        style={{
          color: textColor,
          fontSize: 14,
          fontFamily: fontFamily,
          fontWeight: '500' as const,
          textAlign: 'left' as const,
        }}
      >
        {userName}
      </Text>
    </View>
  );
};
